export default __webpack_public_path__ + "static/media/subgroup.9f112c0e.svg";